// src/pages/NotFound.tsx
// ★ Extracted from App.tsx — branded 404 page with clinic logo

import React from 'react';
import { Link } from 'react-router-dom';
import { CLINIC_CONFIG } from '../config/clinicConfig';

const NotFoundPage: React.FC = () => (
    <div style={{
        display: 'flex', flexDirection: 'column', alignItems: 'center',
        justifyContent: 'center', minHeight: '60vh', padding: '40px 20px',
        textAlign: 'center',
    }}>
        <img src="/logo.png" alt={CLINIC_CONFIG.clinicName} style={{ height: 50, marginBottom: 32, opacity: 0.7 }} />
        <h1 style={{ fontSize: '72px', fontWeight: 800, margin: 0, color: '#212529', lineHeight: 1 }}>404</h1>
        <p style={{ fontSize: '18px', color: '#6c757d', margin: '16px 0 8px', maxWidth: 420 }}>
            The page you're looking for doesn't exist or has been moved.
        </p>
        <p style={{ fontSize: '14px', color: '#adb5bd', marginBottom: '32px' }}>
            Check the URL or head back to our homepage.
        </p>
        <Link
            to="/"
            style={{
                display: 'inline-flex', alignItems: 'center', gap: '8px',
                padding: '12px 28px', borderRadius: '8px',
                background: '#212529', color: '#fff', fontWeight: 600,
                fontSize: '14px', textDecoration: 'none',
                transition: 'background 0.2s ease',
            }}
        >
            ← Go Home
        </Link>
    </div>
);

export default NotFoundPage;
